/**
 * Helper function to determine if a comment is part of a tag comment thread
 * @param {string} parentId - The ID of the parent comment
 * @param {Array} comments - Array of comments to search through
 * @returns {Object} Object containing isTagComment, tagId
 */
export const determineCommentType = (parentId, comments) => {
    // Search for the parent comment in the nested structure
    const findCommentInNestedStructure = (comments, targetId) => {
        for (const comment of comments) {
            if (comment.id === targetId) {
                return comment;
            }
            // Search in replies recursively
            if (comment.replies && comment.replies.length > 0) {
                const foundInReplies = findCommentInNestedStructure(comment.replies, targetId);
                if (foundInReplies) {
                    return foundInReplies;
                }
            }
        }
        return null;
    };

    const parentComment = findCommentInNestedStructure(comments, parentId);
    
    // Check if this comment is part of a tag comment thread
    let isTagComment = false;
    let tagId = null;
    
    if (parentComment) {
        // Check if the parent comment has a Tag property directly
        if (parentComment.Tag) {
            isTagComment = true;
            tagId = parentComment.Tag.id;
        } else if (parentComment.commentable_type === 'Taggable') {
            // This is a tag comment, find the root comment with the same commentable_id
            const findRootCommentByCommentableId = (comments, commentableId) => {
                for (const comment of comments) {
                    if (comment.commentable_id === commentableId && comment.Tag) {
                        return comment;
                    }
                    if (comment.replies && comment.replies.length > 0) {
                        const foundInReplies = findRootCommentByCommentableId(comment.replies, commentableId);
                        if (foundInReplies) {
                            return foundInReplies;
                        }
                    }
                }
                return null;
            };
            
            const rootComment = findRootCommentByCommentableId(comments, parentComment.commentable_id);
            if (rootComment) {
                isTagComment = true;
                tagId = rootComment.Tag.id;
            }
        }
    }
    
    return {
        isTagComment,
        tagId,
    };
};